<template>
  <main>
    <section-hero :bgImg="bgImg" :subtitle="subtitle"></section-hero>
    <section class="section--user-status" id="scrollToOnLoad">
      <b-container class="container--wide">
        <div class="user">
          <b-row class="flex-column flex-sm-row">
            <b-col cols="6" sm="4" offset="3" offset-sm="1"
              class="d-flex align-items-center">
                <img class="user__img" src="/static/assets/img_sign-up.jpg" alt="">
            </b-col>
            <b-col sm="6" class="mt-5 mt-xl-3 text-center text-sm-left">
              <h1 class="text--black text--spacing">{{ $t("nav.logIn") }}</h1>
              <div class="d-flex flex-column flex-sm-row
                justify-content-xl-between justify-content-start ">
                <b-btn
                  @click="showLoginPanel('student')" variant="primary" size="lg"
                  class="mx-auto mx-sm-0" :class="{'btn-primary--active': userType === 'student'}">
                  Student
                </b-btn>
                <b-btn class=" ml-sm-3 mx-auto mx-sm-0"
                  @click="showLoginPanel('teacher')" variant="primary" size="lg"
                   :class="{'btn-primary--active': userType === 'teacher'}">
                  Teacher
                </b-btn>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </section>

    <b-container v-if="modalVisible">
      <b-modal centered :visible="true" @hidden="closeModal()"
        :hide-footer="true" :hide-header="true" class="logModal" id="js-logModal">
        <login-content :userType="userType"/>
      </b-modal>
    </b-container>
    <section v-else class="section--login">
      <b-container class="container--wide">
        <login-content :userType="userType"/>
      </b-container>
    </section>

    <section-support></section-support>
  </main>
</template>

<script>
import Hero from '@/components/Hero';
import Support from '@/components/Support/Index';
import LoginContent from '@/components/Auth/Index';

export default {
  components: {
    'section-hero': Hero,
    'section-support': Support,
    LoginContent,
  },
  data() {
    return {
      bgImg: 'Banner5-My_Account-',
      subtitle: this.$t('nav.myAccount'),
      userType: null,
      modalVisible: false,
    };
  },
  methods: {
    showLoginPanel(userType) {
      this.userType = userType;
      if (window.innerWidth >= 1200) this.modalVisible = true;
    },
    closeModal() {
      this.modalVisible = false;
      this.userType = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./src/styles/helpers/_variables.scss";
@import "./src/styles/helpers/_include-media.scss";

.section--user-status {
  padding: 100px 0 110px;
  @include media("<md") {
    padding: 40px 0;
  }
}
.user {
  background-color: #e4e4e4;
  padding: 135px 0 100px;
  @include media("<lg") {
    padding: 50px 0;
  }
  @include media("<md") {
    padding: 50px 30px;
  }
  &__img {
    width: 250px;
    height: auto;
    margin: 0 auto;
    @include media('<xl') {
      width: 100%;
    }
  }
  &__text {
    color: $color--black;
    font-size: 28px;
    @include media("<md") {
      font-size: 16px;
    }
    @include media("<sm") {
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Auth/Login.vue